/* eslint-disable @angular-eslint/prefer-standalone, @angular-eslint/prefer-inject */
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Subscription } from "rxjs";
import { LayoutType } from "../../../core/configs/config";
import { LayoutService } from "../../../core/layout.service";

@Component({
  selector: "app-sidebar-logo",
  templateUrl: "./sidebar-logo.component.html",
  styleUrls: ["./sidebar-logo.component.scss"],
  standalone: false,
})
export class SidebarLogoComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = [];
  @Input() toggleButtonClass = "";
  @Input() toggleEnabled: boolean;
  @Input() toggleType = "";
  @Input() toggleState = "";

  currentLayoutType: LayoutType | null;

  toggleAttr: string;

  @Output() toggleHover = new EventEmitter();
  @Output() toggleChange = new EventEmitter();

  isToggle = false;
  isHover = false;

  constructor(private layout: LayoutService) {}

  ngOnInit(): void {
    this.toggleAttr = `app-sidebar-${this.toggleType}`;
    const layoutSubscr = this.layout.currentLayoutTypeSubject
      .asObservable()
      .subscribe((layout) => {
        this.currentLayoutType = layout;
      });
    this.unsubscribe.push(layoutSubscr);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  onToggleHover(isHover: boolean) {
    this.isHover = isHover;
    // if (this.isToggle && isHover) {
    //   this.toggleHover.emit(isHover);
    // }
    // setTimeout(() => {}, isHover && this.isToggle ? 0 : 2000);
  }
  onToggleChange() {
    this.isToggle = !this.isToggle;
    this.toggleChange.emit(this.isToggle);
  }

  toggleClick() {
    this.isToggle = !this.isToggle;
    this.toggleChange.emit(this.isToggle);
  }
}
